import { useCallback, useEffect, useRef, useState } from 'react'

export function useColumnConfirmDelete(timeoutMs = 3000) {
  const [confirmingId, setConfirmingId] = useState<string | null>(null)
  const timeoutRef = useRef<number | null>(null)

  const clearTimer = useCallback(() => {
    if (timeoutRef.current !== null) {
      window.clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  const cancelConfirmation = useCallback(() => {
    clearTimer()
    setConfirmingId(null)
  }, [clearTimer])

  const requestDelete = useCallback(
    (id: string, onConfirm: () => void) => {
      if (confirmingId === id) {
        cancelConfirmation()
        onConfirm()
        return true
      }

      clearTimer()
      setConfirmingId(id)
      timeoutRef.current = window.setTimeout(() => {
        setConfirmingId(null)
        timeoutRef.current = null
      }, timeoutMs)
      return false
    },
    [confirmingId, cancelConfirmation, clearTimer, timeoutMs],
  )

  useEffect(() => () => clearTimer(), [clearTimer])

  return {
    confirmingId,
    isConfirming: useCallback((id: string) => confirmingId === id, [confirmingId]),
    requestDelete,
    cancelConfirmation,
  }
}
